module.exports = __webpack_public_path__ + "static/media/TB-soccer-spotlight.1790797c.png";